import Header from '../components/Header'
import Footer from '../components/Footer'
import Head from '../components/Head'
import * as common from '../common/commonFunction'
import commonSession from '../common/commonSession'
import {useEffect,useState} from 'react'
import {COMMUNITY,LOGIN_ALERT1,POST} from "../lib/global_variable"

const pom = () => {

    const sessionInfo = commonSession.getSession()

    useEffect(() => {
        if (sessionInfo.userId == null || sessionInfo.userId == '' ) {
            alert(LOGIN_ALERT1)
            location.href = '/login'
            return false;
        }
    },[])

    return (
        <>
            <Head />
            <Header />
            <div>
                {/* {common.getUserInfo()} */}
            </div>
            <div className="container" onClick={()=>common.focusOutMenu()}>
                <content>
                    <div className="input-form">
                        <div className="row">
                            <div className="title_bar"><hr /></div>
                            <div className="title_bar"><h4 className="text-center">PoM</h4></div>
                            <div className="title_bar"><hr /></div>
                        </div>
                    </div>
                    <div className="input-form">
                        {/* <div className="text-center">
                            <h3 className="py-3">Coming Soon!</h3>
                        </div> */}
                        <div className="text-center">
                            <h3 className="py-3" style={{ fontFamily: "Inconsolata, Monaco, Consolas, 'Courier New', Courier", color: "#2C3E50" }}>Level</h3>
                        </div>
                        <div className="pom-level" style={{ position: "relative", zIndex: "50" }}>
                            <img src="img/xlevel.png" alt="" loading="lazy" style={{ width: "17rem", zIndex: "50" }} />

                            <div style={{ position: "absolute", top: "3rem", left: "60%", zIndex: "49" }}>
                                <img src="img/ylevel.png" alt="" loading="lazy" style={{ opacity: "30%" }} />
                            </div>

                            <div style={{ position: "absolute", top: "5rem", left: "70%", zIndex: "48" }}>
                                <img src="img/zlevel.png" alt="" loading="lazy" style={{ width: "10rem", opacity: "20%" }} />
                            </div>

                            <div style={{ position: "absolute", top: "7rem", left: "80%", zIndex: "47" }}>
                                <img src="img/slevel.png" alt="" loading="lazy" style={{ width: "7rem", opacity: "10%" }} />
                            </div>
                        </div>

                        <div className="code-editor">
                            <div className="log-tab">
                                <div className="tab-title -activityLog">Activity Log</div>
                                <div className="log-tab">
                                    <p className="fs-3" style={{textAlign:"center"}}>Coming Soon</p>
                                    {/* <input type="radio" name="log-tabs" className="tab-title" id="-myHistory" checked />
                                    <label for="-myHistory">All</label>

                                    <input type="radio" name="log-tabs" className="tab-title" id="-nftPurchase" />
                                    <label for="-nftPurchase">NFT Purchase History</label>

                                    <input type="radio" name="log-tabs" className="tab-title" id="-myPost" />
                                    <label for="-myPost">My Posts</label>

                                    <input type="radio" name="log-tabs" className="tab-title" id="-etc" />
                                    <label for="-etc">ETC</label>

                                    <div id="-myHistory_content" className="log-content">
                                        <table border="0" className="lines">
                                            <thead>
                                                <tr>
                                                    <th className="linenumber" style={{ borderBottom: "2px solid #2C3E50", width: "2rem" }}>no.</th>
                                                    <th style={{ borderBottom: "2px solid #2C3E50", width: "25rem" }}>Contents</th>
                                                    <th style={{ borderBottom: "2px solid #2C3E50", width: "8rem" }}>Date</th>
                                                    <th style={{ borderBottom: "2px solid #2C3E50", width: "8rem" }}>Time</th>
                                                    <th style={{ borderBottom: "2px solid #2C3E50", textAlign: "center", width: "7rem" }}>Point</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td className="linenumber">1</td>
                                                    <td>Action Log Content</td>
                                                    <td>2022-07-24</td>
                                                    <td>12:23:34</td>
                                                    <th style={{ textAlign: "center" }}>10pt</th>
                                                </tr>
                                                <tr>
                                                    <td className="linenumber">2</td>
                                                    <td>Action Log Content</td>
                                                    <td>2022-07-24</td>
                                                    <td>12:23:34</td>
                                                    <td style={{ textAlign: "center" }}>10pt</td>
                                                </tr>
                                                <tr>
                                                    <td className="linenumber">3</td>
                                                    <td>Action Log Content</td>
                                                    <td>2022-07-24</td>
                                                    <td>12:23:34</td>
                                                    <td style={{ textAlign: "center" }}>10pt</td>
                                                </tr>
                                                <tr>
                                                    <td className="linenumber">4</td>
                                                    <td>Action Log Content</td>
                                                    <td>2022-07-24</td>
                                                    <td>12:23:34</td>
                                                    <td style={{ textAlign: "center" }}>10pt</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>

                                    <div id="-myPost_content" className="log-content">
                                        <table border="0" className="lines">
                                            <thead>
                                                <tr>
                                                    <th className="linenumber" style={{ borderBottom: "2px solid #2C3E50", width: "2rem" }}>no.</th>
                                                    <th style={{ borderBottom: "2px solid #2C3E50", width: "25rem" }}>Contents</th>
                                                    <th style={{ borderBottom: "2px solid #2C3E50", width: "8rem" }}>Date</th>
                                                    <th style={{ borderBottom: "2px solid #2C3E50", width: "8rem" }}>Time</th>
                                                    <th style={{ borderBottom: "2px solid #2C3E50", textAlign: "center", width: "7rem" }}>Point</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td className="linenumber">1</td>
                                                    <td>My Posting Action Log Content</td>
                                                    <td>2022-07-24</td>
                                                    <td>12:23:34</td>
                                                    <td style={{ textAlign: "center" }}>10pt</td>
                                                </tr>
                                                <tr>
                                                    <td className="linenumber">2</td>
                                                    <td>My Posting Action Log Content</td>
                                                    <td>2022-07-24</td>
                                                    <td>12:23:34</td>
                                                    <td style={{ textAlign: "center" }}>10pt</td>
                                                </tr>
                                                <tr>
                                                    <td className="linenumber">3</td>
                                                    <td>My Posting Action Log Content</td>
                                                    <td>2022-07-24</td>
                                                    <td>12:23:34</td>
                                                    <td style={{ textAlign: "center" }}>10pt</td>
                                                </tr>
                                                <tr>
                                                    <td className="linenumber">4</td>
                                                    <td>My Posting Action Log Content</td>
                                                    <td>2022-07-24</td>
                                                    <td>12:23:34</td>
                                                    <td style={{ textAlign: "center" }}>10pt</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                    <div id="-nftPurchase_content" className="log-content">
                                        <table border="0" className="lines">
                                            <thead>
                                                <tr>
                                                    <th className="linenumber" style={{ borderBottom: "2px solid #2C3E50", width: "2rem" }}>no.</th>
                                                    <th style={{ borderBottom: "2px solid #2C3E50", width: "25rem" }}>Contents</th>
                                                    <th style={{ borderBottom: "2px solid #2C3E50", width: "8rem" }}>Date</th>
                                                    <th style={{ borderBottom: "2px solid #2C3E50", width: "8rem" }}>Time</th>
                                                    <th style={{ borderBottom: "2px solid #2C3E50", textAlign: "center", width: "7rem" }}>Point</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td className="linenumber">1</td>
                                                    <td>NFT Purchase History Action Log Content</td>
                                                    <td>2022-07-24</td>
                                                    <td>12:23:34</td>
                                                    <td style={{ textAlign: "center" }}>10pt</td>
                                                </tr>
                                                <tr>
                                                    <td className="linenumber">2</td>
                                                    <td>NFT Purchase History Action Log Content</td>
                                                    <td>2022-07-24</td>
                                                    <td>12:23:34</td>
                                                    <td style={{ textAlign: "center" }}>10pt</td>
                                                </tr>
                                                <tr>
                                                    <td className="linenumber">3</td>
                                                    <td>NFT Purchase History Action Log Content</td>
                                                    <td>2022-07-24</td>
                                                    <td>12:23:34</td>
                                                    <td style={{ textAlign: "center" }}>10pt</td>
                                                </tr>
                                                <tr>
                                                    <td className="linenumber">4</td>
                                                    <td>NFT Purchase History Action Log Content</td>
                                                    <td>2022-07-24</td>
                                                    <td>12:23:34</td>
                                                    <td style={{ textAlign: "center" }}>10pt</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                    <div id="-etc_content" className="log-content">
                                        <table border="0" className="lines">
                                            <thead>
                                                <tr>
                                                    <th className="linenumber" style={{ borderBottom: "2px solid #2C3E50", width: "2rem" }}>no.</th>
                                                    <th style={{ borderBottom: "2px solid #2C3E50", width: "25rem" }}>Contents</th>
                                                    <th style={{ borderBottom: "2px solid #2C3E50", width: "8rem" }}>Date</th>
                                                    <th style={{ borderBottom: "2px solid #2C3E50", width: "8rem" }}>Time</th>
                                                    <th style={{ borderBottom: "2px solid #2C3E50", textAlign: "center", width: "7rem" }}>Point</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td className="linenumber">1</td>
                                                    <td>ETC Action Log Content</td>
                                                    <td>2022-07-24</td>
                                                    <td>12:23:34</td>
                                                    <td style={{ textAlign: "center" }}>10pt</td>
                                                </tr>
                                                <tr>
                                                    <td className="linenumber">2</td>
                                                    <td>ETC Action Log Content</td>
                                                    <td>2022-07-24</td>
                                                    <td>12:23:34</td>
                                                    <td style={{ textAlign: "center" }}>10pt</td>
                                                </tr>
                                                <tr>
                                                    <td className="linenumber">3</td>
                                                    <td>ETC Action Log Content</td>
                                                    <td>2022-07-24</td>
                                                    <td>12:23:34</td>
                                                    <td style={{ textAlign: "center" }}>10pt</td>
                                                </tr>
                                                <tr>
                                                    <td className="linenumber">4</td>
                                                    <td>ETC Action Log Content</td>
                                                    <td>2022-07-24</td>
                                                    <td>12:23:34</td>
                                                    <td style={{ textAlign: "center" }}>10pt</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div> */}
                                </div>
                            </div>
                        </div>
                    </div>
                </content>
            </div >
            <Footer />
            <script src="https://code.jquery.com/jquery-3.5.1.min.js"></script>
            <script src="/js/pom.js"></script>
        </>
    )
}

export default pom